var path = 'src/app/auth/login.html';
var html = "<div page-wrapper> <h1 class=page-header>Login</h1> <div login-form></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/login.html
 ** module id = 33
 ** module chunks = 0
 **/